export default __webpack_public_path__ + "static/media/fNeutral27.6b173427.png";